import React, { Component } from "react";
import { withRouter } from '../../common/with-router';

class AtendimentoGotoPostback extends Component {
    componentDidMount(){
        //pega o accesstoken dos parametros da url
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const token = params.get('access_token');

        localStorage.setItem("tokenG", token);

        window.close();       
    }

    render(){
        return <></>
    }
}

export default withRouter(AtendimentoGotoPostback);